module.exports = __webpack_public_path__ + "img/search.d8651fc7.svg";